import { render, staticRenderFns } from "./StockEvents.vue?vue&type=template&id=06d60499&scoped=true"
import script from "./StockEvents.vue?vue&type=script&lang=js"
export * from "./StockEvents.vue?vue&type=script&lang=js"
import style0 from "./StockEvents.vue?vue&type=style&index=0&id=06d60499&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d60499",
  null
  
)

export default component.exports